"use client";
import { jsx as a } from "react/jsx-runtime";
import { memo as m } from "react";
import t from "../components/Icon/SvgIcon.js";
const e = (o) => /* @__PURE__ */ a(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.163 8.563a1.314 1.314 0 1 1 2.627.002 1.314 1.314 0 0 1-2.627-.002m-1.25 0a2.567 2.567 0 0 0 2.563 2.565A2.567 2.567 0 0 0 9.04 8.563 2.566 2.566 0 0 0 6.476 6a2.566 2.566 0 0 0-2.563 2.563M2 15.391a.625.625 0 0 0 1.25 0v-1.374c0-.58.471-1.05 1.05-1.05h3.632a.626.626 0 0 0 0-1.25H4.3a2.3 2.3 0 0 0-2.3 2.3zM17.523 7.25a1.314 1.314 0 1 0 .002 2.628 1.314 1.314 0 0 0-.002-2.628m0 3.878a2.567 2.567 0 0 1-2.563-2.565A2.566 2.566 0 0 1 17.523 6a2.566 2.566 0 0 1 2.564 2.563 2.567 2.567 0 0 1-2.564 2.565m3.227 4.263a.625.625 0 0 0 1.25 0v-1.374c0-1.27-1.031-2.3-2.3-2.3h-3.633a.626.626 0 0 0 0 1.25H19.7c.579 0 1.05.47 1.05 1.05zM12 9.035a1.444 1.444 0 0 0 0 2.887 1.444 1.444 0 0 0 0-2.887m0 4.137a2.696 2.696 0 0 1-2.693-2.694A2.696 2.696 0 0 1 12 7.785a2.696 2.696 0 0 1 2.692 2.693A2.696 2.696 0 0 1 12 13.172m3.482 4.213a.625.625 0 0 0 1.25 0v-1.466a2.414 2.414 0 0 0-2.412-2.411H9.678a2.414 2.414 0 0 0-2.41 2.41v1.467a.625.625 0 0 0 1.25 0v-1.466c0-.64.52-1.161 1.16-1.161h4.642c.641 0 1.162.52 1.162 1.16z",
        clipRule: "evenodd"
      }
    )
  }
), i = m(e);
export {
  i as AboutUs,
  i as default
};
